import { styled } from "@mui/material";
import FormHelperText from "@mui/material/FormHelperText";
import Switch from "@mui/material/Switch";
import { theme } from "styles/themes";

export const LabelGroupWrapper = styled("div")(() => ({
  display: "flex",
  flexDirection: "column",
}));

export const StyledHelperText = styled(FormHelperText)<{ error?: boolean }>(() => ({
  lineHeight: "10px",
  marginTop: "-10px",
  color: `${({ error }) => (error ? "red" : "black")}`,
}));

export const StyledFormLabel = styled("div")(({ marginBottom = "8px" }: { marginBottom?: string }) => ({
  fontSize: "12px",
  fontWeight: "600",
  lineHeight: "9px",
  marginBottom,
  color: theme.colors["nepal-blue"],
  textTransform: "uppercase",
}));

export const StyledSwitchWrapper = styled("div")(() => ({
  display: "flex",
  alignItems: "center",
}));

export const StyledSwitch = styled(Switch)(() => ({
  "& .MuiSwitch-switchBase": {
    padding: "0",
    margin: "2px",
    transitionDuration: "300ms",
    "&.Mui-checked": {
      transform: "translateX(7px)",
      color: theme.colors.white,
      "& + .MuiSwitch-track": {
        backgroundColor: theme.colors["blue-ribbon"],
        opacity: "1",
        border: "0",
      },
      "&.Mui-disabled + .MuiSwitch-track": {
        opacity: "0.5",
      },
    },
    "&.Mui-focusVisible .MuiSwitch-thumb": {
      color: "#33cf4d",
      border: `6px solid ${theme.colors.white}`,
      boxShadow: "none",
    },
    "&.Mui-disabled .MuiSwitch-thumb": {
      color: theme.colors["botticelli-blue"],
      boxShadow: "none",
    },
    "&.Mui-disabled + .MuiSwitch-track": {
      opacity: theme.colors["graham-grey"],
    },
  },
  "& .MuiSwitch-thumb": {
    boxSizing: "border-box",
    width: "11px",
    height: "11px",
    boxShadow: "none",
  },
  "& .MuiSwitch-track": {
    borderRadius: "13px",
    backgroundColor: theme.colors["graham-grey"],
    opacity: 1,
  },
}));

export const TooltipText = styled("div")(() => ({
  fontSize: "16px",
  padding: "3px",
}));

export const TooltipIcon = styled("div")(() => ({
  transform: "matrix(1, 0, 0, -1, 0, 0)",
  fontSize: "10px",
  lineHeight: "10px",
  fontWeight: 500,
  color: theme.colors["graham-grey"],
  border: `1px solid ${theme.colors["graham-grey"]}`,
  width: "14px",
  height: "14px",
  borderRadius: "50%",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  marginLeft: "8px",
  marginBottom: "-2px",
}));

export const StyledSwitchText = styled("div")(() => ({
  fontFamily: "Barlow",
  fontWeight: "500",
  lineHeight: "14px",
  color: theme.colors["queen-blue"],
  marginLeft: "10px",
}));
